define('BanNoticeView',['backbone', 'router', 'notificationFx'], function (Backbone, router, NotificationFx) {

    var BanNoticeView = Backbone.View.extend({
        initialize: function (text) {
            var notification = new NotificationFx({
                message : '<p><span class="icon icon-plus"></span>'+ text +'</p>',
                layout : 'bar',
                effect : 'exploader',
                ttl : 3000,
                type : 'notice' // notice, warning or error
            });
            notification.show();
        }
    });
    
    return BanNoticeView;
});
